const SURVEY_TAKING_ROUTE_PREFIXES = [
  '/van-hoa/khao-sat/lam-bai',
  '/quy-trinh/khao-sat/lam-bai',
];

export function isSurveyTakingPath(pathname: string | null | undefined): boolean {
  const normalized = String(pathname ?? '')
    .split(/[?#]/, 1)[0]
    .replace(/\/+$/, '')
    .toLowerCase();

  return SURVEY_TAKING_ROUTE_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
  );
}

/**
 * IIS serves the exported root index for dynamic deep links, so Next may
 * initially report router.pathname as "/" while window.location is correct.
 */
export function isSurveyTakingRoute(
  routerPathname: string | null | undefined,
  browserPathname?: string | null,
): boolean {
  return isSurveyTakingPath(routerPathname) || isSurveyTakingPath(browserPathname);
}
